import { render } from "./footer-grid.vue?vue&type=template&id=57b23830&scoped=true"
import script from "./footer-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-grid.vue?vue&type=script&setup=true&lang=js"

import "./footer-grid.vue?vue&type=style&index=0&id=57b23830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b23830"],['__file',"src/components/grid-card-component/footer-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57b23830"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57b23830', __exports__)) {
    api.reload('57b23830', __exports__)
  }
  
  module.hot.accept("./footer-grid.vue?vue&type=template&id=57b23830&scoped=true", () => {
    api.rerender('57b23830', render)
  })

}


export default __exports__